module.exports = __webpack_public_path__ + "images/emoji/black_joker.5064a4ca1e223cfb3f3c.png";